import { sub } from "date-fns";

export const lg_forgotpassword = {
    lg_forgotpassword_th: {
        title: "ลืมรหัสผ่านใช่หรือไม่?",
        subtitle1: "กรุณาป้อนอีเมลของคุณ แล้วเราจะส่งลิงก์สำหรับการรีเซ็ตรหัสผ่านให้คุณ",
        subtitle2: "ไม่ได้รับอีเมลใช่ไหม? ลองตรวจสอบในโฟลเดอร์สแปมหรือถังขยะดู",
        subtitle3: "ยังคงประสบปัญหาอยู่หรือไม่?",
        subtitle4: "ติดต่อเรา",
        subtitleforemail: "โปรดตรวจสอบให้แน่ใจว่าคุณได้ป้อนอีเมลที่ใช้ในการลงทะเบียน", 
        label:"อีเมล",
        placeholder:"exam@email.com",
        backbutton:"กลับ",
        send:"ส่งลิงก์รีเซ็ต",
        put_required:"ใส่อีเมล!!!",
        reset_title:"ส่งลิงก์รีเซ็ตเรียบร้อยแล้ว",
        reset_subtitle1:"เราได้ส่งลิงก์ไปยังอีเมลของคุณแล้ว กรุณาคลิกเพื่อทำการรีเซ็ตรหัสผ่านของคุณ",
        reset_btn:"กลับสู่หน้าลงชื่อเข้าใช้",
    },
    lg_forgotpassword_en: {
        title: "Forgot Your Password?",
        subtitle1:"Enter your email and we’ll send you a link to reset your password.",
        subtitle2: "Didn’t get the email? Check your spam or junk folder.", 
        subtitle3: "Still having trouble?",
        subtitle4: "Contact Us",
        subtitleforemail: "Make sure you enter the email you used to register.",  
        label:"Email",
        placeholder:"exam@email.com",
        backbutton:"Back",
        send:"Send Reset Link",
        put_required:"Email required!!!",
        reset_title:"Reset link sent successfully.",
        reset_subtitle1:"We’ve emailed you a link — just click it to reset your password.",
        reset_btn:"Return to Login",
    },
  };
